
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import { addCommissionAgent } from "./../../../actions/add-commission-agent-action";
import Confirmation from '../../common/modals/confirmation.component.js';

function TableRow(props) {
  const { fromAmount: propFromAmount, toAmount: propToAmount, commission: propCommission, index, isEditing, onEdit, onSave, onDelete, onAdd,rows } = props;

  // Initialize local state with props
  const [fromAmount, setFromAmount] = useState(propFromAmount);
  const [toAmount, setToAmount] = useState(propToAmount);
  const [commission, setCommission] = useState(propCommission);

  // // Update local state when props change
  React.useEffect(() => {
    setFromAmount(propFromAmount);
    setToAmount(propToAmount);
    setCommission(propCommission);
  }, [propFromAmount, propToAmount, propCommission]);

  return (
    <>
    <tr>
      <td className="form-controlr">
        {isEditing ? <input type="number"  className="form-control" disabled value={fromAmount} onChange={(e) => setFromAmount(e.target.value)} /> : fromAmount}
      </td>
      <td className="form-controlr">
        {isEditing ? <input type="number"  className="form-control" value={toAmount} onChange={(e) => setToAmount(e.target.value)} /> : toAmount}
      </td>
      <td className="form-controlr">
        {isEditing ? <input type="number"  className="form-control" value={commission} onChange={(e) => setCommission(e.target.value)} /> : commission}
      </td>
      <td>
        {isEditing ? (
          <>
            <strong className="tooltip" onClick={() => onSave(index,toAmount,fromAmount,commission)}>
              <i className="fa fa-save" aria-hidden="true"></i>
              <span className="tooltiptext">Save</span>
            </strong>
            {/* <strong className="delete tooltip" onClick={() => onDelete(index)}>
              <i className="fa fa-trash" aria-hidden="true"></i>
              <span className="tooltiptext">Delete</span>
            </strong>
             */}
          </>
        ) : (
          <>
            <strong className="edit tooltip" onClick={() => onEdit(index)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
              <span className="tooltiptext">Edit</span>
            </strong>
            {index === rows.length - 1 && rows.length>1 && !isEditing && (
            <strong className="delete tooltip" onClick={() => onDelete(index)}>
              <i className="fa fa-trash" aria-hidden="true"></i>
              <span className="tooltiptext">Delete</span>
            </strong>
            )}
            {index === rows.length - 1 &&  !isEditing && (
            <strong className="delete tooltip" onClick={() => onAdd(index,toAmount,fromAmount,commission)}>
              <i className="fa fa-plus" style={{color:'black'}} aria-hidden="true"></i>
              <span className="tooltiptext">Add</span>
            </strong>
            )}
          </>
        )}
      </td>
    </tr>
 
    {/* <tr style={{ visibility: "hidden" }}
   ><td ><input class="form-control" id="from_amount" type="number" data-decimal="2"/></td><td><input class="form-control" id="to_amount" type="number" data-decimal="2"/></td><td><input class="form-control" id="commission" type="number" data-decimal="2"/></td><td><strong class="add tooltip"><i class="fa fa-plus" aria-hidden="true"></i><span class="tooltiptext">Add</span></strong></td></tr> */}
    
</>
  );
}

function DataTable() {
  const maxLimit = 9999999;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("list_per_details5");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);

  const[rowSave, setRowSave] = React.useState(true);
  const[rowSaveP, setRowSaveP] = React.useState(true);
  const userData = useSelector(state => state.authReducer);

  const[userType, setUserType] = React.useState(true);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const initialErrorsState = {
    group_name: "",
    payinSalab: "",
    payOutSalab: "",
  }
  const [errors, setErrors] = useState({ ...initialErrorsState });

  const [groupFromData, setGroupFromData] = useState({
    group_name: "",
    default_commission_group_agent: false,
    default_commission_group_merchant: false,
    commission_type_id: 'P',
    commission_type_id_payout: 'P'
  });
  const [rows, setRows] = useState([]);
  const [rowsP, setRowsP] = useState([]);
  const validateField = (fieldName, value) => {
    let errorMessage = "";

    if (fieldName === "group_name" && !value.trim()) {
      errorMessage = "Group Name is required";
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
   
    setGroupFromData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const addRow = (index,toAmount,fromAmount) => {
    const newRowToAmount = parseInt(toAmount);
    if (newRowToAmount >= maxLimit) {
      // Display an error message or perform some action to notify the user
      toast.info("To Amount should be less than " +maxLimit)
      return;
    }
    const newRow = { fromAmount: toAmount, toAmount: maxLimit, commission: 1.0, isEditing: false };
    setRows([...rows, newRow]);
  };

  
  const editRow = (index) => {

    const updatedRows = [...rows];
    updatedRows[index].isEditing = true;
    setRowSave(false)
    setRows(updatedRows);
  };

  const saveRow = (index,toAmount,fromAmount,commission) => {
    if(commission < 0 ) {
      toast.error(MESSAGES.NGT_NT_ALLOWED)
      return
    }
    if(!toAmount){
      toast.error(MESSAGES.TO_AMT_BLNK)
      return
    }
   
    if(toAmount > maxLimit){
      toast.info("To Amount should be less than " + maxLimit)
      return
    }
    if (index < rows.length - 1 && toAmount > Number(rows[index + 1].toAmount)) {
      toast.info("To Amount should be less than the next To Amount");
      return;
    }
    if (toAmount < fromAmount) {
      toast.info("To Amount should not be less than From Amount");
      return;
  }

    const updatedRows = [...rows];
    updatedRows[index].isEditing = false;
    updatedRows[index].toAmount = toAmount;
    updatedRows[index].commission = commission;
    if (index < updatedRows.length - 1) {
    
      updatedRows[index + 1].fromAmount = toAmount;
  }

    setRows(updatedRows);
    setRowSave(true)
  };

  const deleteRow = (index) => {
    const updatedRows = [...rows];
    if (index === updatedRows.length - 1) {
       
        updatedRows[index-1].toAmount = maxLimit;
    }
    updatedRows.splice(index, 1);
    setRows(updatedRows);
  };




  const addRowP = (index,toAmount,fromAmount,commission) => {
    const newRowToAmount = parseInt(toAmount);
    if (newRowToAmount >= maxLimit) {
      // Display an error message or perform some action to notify the user
      toast.info("To Amount should be less than "+maxLimit)
      return;
    }
    const newRow = { fromAmount: toAmount, toAmount: maxLimit, commission: commission, isEditing: false };
    setRowsP([...rowsP, newRow]);
  };

  
  const editRowP = (index) => {
    const updatedRows = [...rowsP];
    updatedRows[index].isEditing = true;
    setRowSaveP(false)
    setRowsP(updatedRows);
  };

  const saveRowP = (index,toAmount,fromAmount, commission) => {
    if(commission < 0 ) {
      toast.error(MESSAGES.NGT_NT_ALLOWED)
      return
    }
      
    if(!toAmount){
      toast.error(MESSAGES.TO_AMT_BLNK)
      return
    }
    if(toAmount > maxLimit){
      toast.info("To Amount should be less than " + maxLimit)
      return
    }
    if (index < rowsP.length - 1 && toAmount > Number(rowsP[index + 1].toAmount)) {
      toast.info(MESSAGES.AMOUNT_VALID_LESS);
      return;
    }
    if (toAmount < fromAmount) {
      toast.info(MESSAGES.AMOUNT_VALID_LESS_FRM);
      return;
    }
    const updatedRows = [...rowsP];
    updatedRows[index].isEditing = false;
    updatedRows[index].toAmount = toAmount;
    if (index < updatedRows.length - 1) {
    
      updatedRows[index + 1].fromAmount = toAmount;
  }
  setRowSaveP(true)
    setRowsP(updatedRows);
  };

  const deleteRowP = (index) => {
    const updatedRows = [...rows];
    if (index === updatedRows.length - 1) {
       
        updatedRows[index-1].toAmount = maxLimit;
    }
    updatedRows.splice(index, 1);
    setRowsP(updatedRows);
  };






  const handleNextClick = () => {
    // // Validate form fields
    Object.keys(groupFromData).forEach((fieldName) =>
      validateField(fieldName, groupFromData[fieldName])
    );
    const hasErrors = Object.values(groupFromData).some(
      (value) => value === ""
    );
    if(!hasErrors && rowSave) {
      handleTabClick("list_address_details5");
      
    }else if(!hasErrors){
      if(rowSave == false) {
        setModalShow(true)
      }
    }
   

  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(rowSaveP == false) {
      setModalShow(true)
      return false
    }
    
    let payInSlabs = [];
    let payOutSlabs = [];

    for(var i=0; i<rows.length; i++) {
      payInSlabs.push({
        from_amount: rows[i].fromAmount,
        to_amount: rows[i].toAmount,
        commission: rows[i].commission
      })
    }

    for(var j=0; j<rowsP.length; j++) {
      payOutSlabs.push({
        from_amount: rowsP[j].fromAmount,
        to_amount: rowsP[j].toAmount,
        commission: rowsP[j].commission
      })
    }

    let requsetData = {
      group_name : groupFromData.group_name,
      default_commission_group_agent: Boolean(groupFromData.default_commission_group_agent),
      default_commission_group_merchant: Boolean(groupFromData.default_commission_group_merchant),
      payin: {
        commission_type_id: groupFromData.commission_type_id,
        slabs: payInSlabs
      },
      payout: {
          commission_type_id: groupFromData.commission_type_id_payout,
          slabs: payOutSlabs
      }
    }

    setLoading(true);
    dispatch(addCommissionAgent(requsetData))
      .then((response) => {
        setLoading(false);
        toast.success(MESSAGES.AGENT_COMMISON_CREATED);
        navigate("/commission-groups");
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        setLoading(false);
        // setErrorMsg(errorMessage.error.message);
        toast.error(errorMessage.error.message);
      });
   


  }

  const updateStatus = () => {
   setRowSave(true);
   setRowSaveP(true)
   setModalShow(false)
  }


  useEffect(() => {
    setUserType(userData.user.data.role.role_code)
    setRows([{ fromAmount: 0.0, toAmount: maxLimit, commission: 1.0, isEditing: false }]);
    setRowsP([{ fromAmount: 0.0, toAmount: maxLimit, commission: 1.0, isEditing: false }]);
  }, []);

  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div class="container-fluid px-4" style={{ paddingBottom: "30px" }}>
      <h4 style={{ marginTop: "0", fontWeight: "700", fontSize: "16px" }}>
        Agent Commission Group
      </h4>
      <div
        class="container-fluid ghty"
        style={{ backgroundColor: "white", height: "auto" }}
      >
        <div className="row" style={{paddingTop: '10px', borderBottom: '1px solid #eff2f7'}}>
      <div className="col-md-3">
        <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="g_name" className="required">GROUP NAME</label>
          <input        type="text"
                          id="group_name"
                         
                          className={`form-control ${errors.group_name ? 'is-invalid' : ''}`}
                          placeholder="Enter Group Name"
                          name="group_name"
                          value={groupFromData.group_name}
                          onChange={handleChange}/>
                          <span id="error_g_name" class="text-danger">
                            {errors.group_name}
                          </span>
        </div>
      </div>
      
        
        <div className="col-md-3 cvbg">
          <div className="form-group frm" style={{textAlign: 'left'}}>
            <label htmlFor="Transaction">AGENT DEFAULT</label>
            <select onChange = {handleChange} name="default_commission_group_agent" value={groupFromData.default_commission_group_agent}  id="transaction_type">
              <option value="true">Yes</option>
              <option value="false">No</option>
              {/* Add more options as needed */}
            </select>
            <span id="error-message" className="text-danger" />
          </div>
        </div>
        {userType !='DADMIN' && (
          <>
        <div className="col-md-3 cvbg">
          <div className="form-group frm" style={{textAlign: 'left'}}>
            <label htmlFor="Transaction">MERCHANTS DEFAULT</label>
            <select name="default_commission_group_merchant" value={groupFromData.default_commission_group_merchant} onChange = {handleChange} id="transaction_type">
              <option value="true">Yes</option>
              <option value="false">No</option>
              {/* Add more options as needed */}
            </select>
            <span id="error-message" className="text-danger" />
          </div>
        </div>
        </>
      )}
      
    </div>
        <form
          method="post"
          id="register_form"
          class="merchant_form"
          onSubmit={handleSubmit}
          
        >
          <ul class="nav nav-tabs">
            <li class="nav-item tbbtrn">
              <a
                className={`nav-link ${
                  activeTab === "list_per_details5"
                    ? "active_tab1"
                    : "inactive_tab1"
                }`}
                id="list_per_details5"
              >
                Payin
              </a>
            </li>
            <li class="nav-item tbbtrn">
              <a
                className={`nav-link ${
                  activeTab === "list_address_details5"
                    ? "active_tab1"
                    : "inactive_tab1"
                }`}
                id="list_address_details5"
              >
                Payout
              </a>
            </li>
          </ul>
          <div class="tab-content" style={{ marginTop: "16px" }}>
            {/* {activeTab === "list_per_details5" && ( */}
            <div
              className={`tab-pane ${
                activeTab === "list_per_details5" ? "active" : "fade"
              }`}
              id="per_details4"
            >
              <div class="panel panel-default">
                <div class="panel-body" style={{ padding: 0 }}>
                  <div class="col-md-12" style={{ padding: 0 }}>
                    <div
                      class="col-md-4 cvbg"
                      style={{ width: "25.5%", marginRight: "15px" }}
                    >
               
                    </div>
                    <div class="col-md-4 cvbg" style={{ width: "25.5%" }}>
                      <div
                        class="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label class="required" for="Transaction">
                          COMMISSION TYPE
                        </label>
                        <select
                          name="commission_type_id"
                          id="transaction_type"
                         value={groupFromData.commission_type_id}
                        onChange={handleChange}
                        >
                          <option value="F">Fixed</option>
                          <option value="P">Percentage</option>
                        </select>
                        <span id="error-message" class="text-danger"></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-12"
                    style={{ padding: 0, marginBottom: "10px" }}
                  >
                   

                   <div id="wrapper">
                    
                    <table className="tofroms"
                        align="left"
                        cellspacing="2"
                        cellpadding="2">

                 
                        <tr>
                          <th >From Amount</th>
                          <th>To Amount</th>
                          <th> <span
                                id="select_commission_type"
                                style={{ marginRight: "5px" }}
                              ></span>Commission</th>
                        </tr>
               
                      <tbody>
                        {rows.map((row, index) => (
                          <TableRow
                            key={index}
                            fromAmount={row.fromAmount}
                            toAmount={row.toAmount}
                            commission={row.commission}
                            isEditing={row.isEditing} // Pass isEditing prop to TableRow
                            index={index}
                            onEdit={editRow}
                            onSave={saveRow}
                            onDelete={deleteRow}
                            onAdd={addRow}
                            rows={rows} // Pass rows as a prop to TableRow
                          />
                        ))}
                  
                      </tbody>
                    </table>
                  </div>




                  </div>
                  <br />
                  <span id="error_g_name" class="text-danger">
                    {errors.payinSalab}
                  </span>
                  <div align="left">
                    <button
                      type="button"
                      name="btn_login_details4"
                      id="btn_login_details4"
                      class="btn ddfg"
                      onClick={() => handleNextClick()}
                    >
                      Next
                    </button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            {/* )} */}
            {/* Render tab content based on activeTab state */}
            {/* {activeTab === "list_address_details5" && ( */}
            <div
              className={`tab-pane ${
                activeTab === "list_address_details5" ? "active" : "fade"
              }`}
              id="address_details5"
            >
              <div class="panel panel-default">
                <div class="panel-body" style={{ padding: 0 }}>
                  <div class="col-md-12" style={{ padding: 0 }}>
                    <div
                      class="col-md-4 cvbg"
                      style={{ width: "25.5%", marginRight: "15px" }}
                    >
           
                    </div>
                    <div class="col-md-4 cvbg" style={{ width: "25.5%" }}>
                      <div
                        class="form-group frm"
                        style={{ textAlign: "left" }}
                      >
                        <label class="required" for="Transaction">
                          COMMISSION TYPE
                        </label>
                        <select
                          name="commission_type_id_payout"
                          id="transaction_type_payout"
                          value={groupFromData.commission_type_id_payout}
                          onChange={handleChange}
                        >
                          <option value="F">Fixed</option>
                          <option value="P">Percentage</option>
                        </select>
                        <span id="error-message" class="text-danger"></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-12"
                    style={{ padding: 0, marginBottom: "10px" }}
                  >
             
             <div id="wrapper">
                    
                    <table className="tofroms"
                        align="left"
                        cellspacing="2"
                        cellpadding="2">

                 
                        <tr>
                          <th >From Amount</th>
                          <th>To Amount</th>
                          <th> <span
                                id="select_commission_type"
                                style={{ marginRight: "5px" }}
                              ></span>Commission</th>
                        </tr>
               
                      <tbody>
                        {rowsP.map((row, index) => (
                          <TableRow
                            key={index}
                            fromAmount={row.fromAmount}
                            toAmount={row.toAmount}
                            commission={row.commission}
                            isEditing={row.isEditing} // Pass isEditing prop to TableRow
                            index={index}
                            onEdit={editRowP}
                            onSave={saveRowP}
                            onDelete={deleteRowP}
                            onAdd={addRowP}
                            rows={rowsP} // Pass rows as a prop to TableRow
                          />
                        ))}
                  
                      </tbody>
                    </table>
                  </div>





                  </div>
                  <br />
                  <span id="error_g_name" class="text-danger">
                    {errors.payOutSalab}
                  </span>
                  <div align="left">
                    <button
                      type="button"
                      name="previous_btn_personal_details4"
                      id="previous_btn_personal_details4"
                      class="btn ddfgg"
                      onClick={() => handleTabClick("list_per_details5")}
                    >
                      Previous
                    </button>
                    <button
                      type="submit"
                      name="btn_asubmite"
                      id="btn_asubmite"
                      class="btn ddfg"
                      style={{ marginLeft: 5 }}
                    >
                      Submit
                    </button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            {/* )} */}
          </div>
        </form>
      </div>
    </div>
    <Confirmation  show={modalShow} onHide={() => updateStatus(false)} onSave={(data) => updateStatus()} modalId='commsionRange' ></Confirmation>
  </div>

   
  );
}
export default DataTable;
